import React, { useState, useEffect } from "react";
import QuestionTitle from "../QuestionTitle";
import TestImageImg from "../../../../../assets/images/joftPooch/pictureTestImg.jpg";
import ConnnectContainer from "./ConnnectContainer";
import { useSelector, useDispatch } from "react-redux";
import { baseURL } from "../../../../../assets/constants/baseUrl";
import { setQuestionAnswer } from "../../../../../assets/redux/actions/Quiz";
import CustomHint from "../../../../../assets/containers/CustomHint";

export default function ConnectQuestion() {
  const dispatch = useDispatch();
  const { currentQuestion, rightAnswer } = useSelector(({ quiz }) => quiz);
  const [connectedOpts, setConnectedOpts] = useState([]);

  useEffect(() => {
    if (currentQuestion) {
      dispatch(
        setQuestionAnswer({
          questionId: currentQuestion._id,
          userOptionsConnectingAnswer: connectedOpts,
        })
      );
    }
    return () => {
      dispatch(setQuestionAnswer(null));
    };
  }, [connectedOpts, currentQuestion, dispatch]);

  return (
    <div className="w-100">
      {rightAnswer && (
        <div className="my-5">
          <CustomHint hint={`پاسخ صحیح: ${rightAnswer}`} />
        </div>
      )}
      <QuestionTitle
        title={currentQuestion?.title}
        imgSrc={
          currentQuestion
            ? currentQuestion.hasOwnProperty("cover")
              ? currentQuestion.cover
                ? `${baseURL}file/get/${currentQuestion.cover}`
                : TestImageImg
              : TestImageImg
            : TestImageImg
        }
      />
      {currentQuestion && (
        <ConnnectContainer
          leftSide={currentQuestion.optionsConnecting.map(
            (item) => item.split("|")[1]
          )}
          rightSide={currentQuestion.optionsConnecting.map(
            (item) => item.split("|")[0]
          )}
          onConnect={(lines) => {
            setConnectedOpts(lines);
          }}
        />
      )}
    </div>
  );
}
